import { SvgIcon } from "@mui/material";

import InformationCircleIcon from "@heroicons/react/24/outline/InformationCircleIcon";

const TableNicNoteAction = () => {
  return (
    <SvgIcon
      color="primary"
      sx={{
        width: "1.35rem",
      }}
    >
      <InformationCircleIcon />
    </SvgIcon>
  );
};

export default TableNicNoteAction;
